import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/builds/triyaru/desktop-frontend-2/layouts/default.vue").then(m => m.default || m)),
  error: defineAsyncComponent(() => import("/builds/triyaru/desktop-frontend-2/layouts/error.vue").then(m => m.default || m))
}